import { AlertCircle, CheckCircle2, Info, X } from 'lucide-react'
import { useToastStore } from '../stores/toast'

const icons = {
  error:   <AlertCircle  className="w-4 h-4 shrink-0 text-red-500"   />,
  success: <CheckCircle2 className="w-4 h-4 shrink-0 text-green-500" />,
  info:    <Info         className="w-4 h-4 shrink-0 text-blue-500"  />,
}

const bg = {
  error:   'border-red-200   bg-red-50   dark:bg-red-950/40   dark:border-red-800',
  success: 'border-green-200 bg-green-50 dark:bg-green-950/40 dark:border-green-800',
  info:    'border-blue-200  bg-blue-50  dark:bg-blue-950/40  dark:border-blue-800',
}

export function Toaster() {
  const { toasts, remove } = useToastStore()

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 max-w-sm w-full pointer-events-none">
      {toasts.map(t => (
        <div
          key={t.id}
          className={`pointer-events-auto flex items-start gap-3 rounded-lg border px-4 py-3 shadow-md text-sm ${bg[t.type]}`}
        >
          {icons[t.type]}
          <span className="flex-1 leading-snug">{t.message}</span>
          <button
            onClick={() => remove(t.id)}
            className="shrink-0 opacity-60 hover:opacity-100 transition-opacity"
            aria-label="Dismiss"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      ))}
    </div>
  )
}
